import type { ComponentProps } from 'react';

export const UploadIcon = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      fill='none'
      height='24'
      viewBox='0 0 24 24'
      width='24'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        clipRule='evenodd'
        d='M9.70716 6.62186L11.5 4.82876V13.9148H13.5V4.82876L15.2928 6.62186L16.7072 5.20774L13.2072 1.70725L12.5 1L11.7928 1.70725L8.29284 5.20774L9.70716 6.62186ZM21 11.5153C21 9.79874 19.6041 8.4154 17.8908 8.41529H17.8906L16.5002 8.41501L16.4998 10.415L17.8904 10.4153H17.8906C18.5079 10.4153 19 10.9116 19 11.5153V20.3153C19 20.9189 18.5079 21.4153 17.8906 21.4153H7.10938C6.49214 21.4153 6 20.9189 6 20.3153V11.5153C6 10.9116 6.49214 10.4153 7.10938 10.4153H7.10952L9.00014 10.415L8.99986 8.41501L7.10938 8.41529H7.10923C5.3959 8.41537 4 9.79872 4 11.5153V20.3153C4 22.0319 5.39598 23.4153 7.10938 23.4153H17.8906C19.604 23.4153 21 22.0319 21 20.3153V11.5153Z'
        fill='white'
        fillRule='evenodd'
      />
    </svg>
  );
};
